// extracted by mini-css-extract-plugin
module.exports = {"skeleton-placeholder":"skeleton-place-holder_skeleton-placeholder__V4L8r","skeletonAnimation":"skeleton-place-holder_skeletonAnimation__KnmVp"};